import React, { useState, useEffect, useCallback } from 'react'
import * as components from '../../components'
import * as rest from '../../services'
import { useDispatch } from 'react-redux'
import { OptionsDataGrid } from './OptionsDataGrid'
import AddOptionsFormPane from './AddOptionsFormPane'
import { showErrorToast } from '../../state/toasts'
export const OptionsManagementPage = (props) => {
  const dispatch = useDispatch()
  const [gridData, setGridData] = useState({})
  const [getAPIResults, setGetAPIResult] = useState(null)
  const [listTypes, setListTypes] = useState([])

  const [hiddenRowKeys, setHiddenRowKeys] = useState([])
  const handleTableChange = (type, { page, sizePerPage }) => {
    const paginationFilters = {
      ...gridData,
      page: page,
      page_size: sizePerPage,
    }
    setGridData(paginationFilters)
  }
  useEffect(()=>{
    new rest.ListService().getListTypes().then(res=>{
        setListTypes(res)
    })
  },[])
  const onFilter = (data) => {
    const searchFilters = data ? { ...data, page: 1 } : gridData
    setGridData({ ...searchFilters })
  }
   const handleRefresh = (data) => {
    const searchFilters = data ? { ...data, page: 1 } : gridData
       setGridData({ ...gridData })
  }
  const getData = useCallback(
    (data) => {
      let finalPayload = { ...gridData, ...data }
      setGetAPIResult(null)
      new rest.ListService()
        .makeGetRequest(finalPayload)
        .then((response) => {
          setGetAPIResult(response)
        })
        .catch((errors) => {
          dispatch(
            showErrorToast('Could Not Load  Data.', JSON.stringify(errors))
          )
        })
    },
    [dispatch, gridData]
  )
  useEffect(() => {
    getData()
  }, [getData, dispatch])
  return !getAPIResults ? (
    <components.Loading />
  ) : (
    <>
      <OptionsDataGrid
        handleTableChange={handleTableChange}
        onFilter={onFilter}
        onRefresh={handleRefresh}
        getData={getData}
        hiddenRowKeys={hiddenRowKeys}
        results={getAPIResults.results}
        pageSize={getAPIResults.page_size}
        count={getAPIResults.count}
        current={getAPIResults.current}
        onDelete={(item) => {
          setHiddenRowKeys([...hiddenRowKeys, item.url])
        }}
        listTypes={listTypes}
      >
        <AddOptionsFormPane
          OnSuccess={(data) => {
            getData()
          }}
        />
      </OptionsDataGrid>
    </>
  )
}
